// Copyright © 2021 Move Closer
export const modalWrapperConfig = {
    closable: true,
    closableWithOutsideClick: true
};
